import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für den Worker-Bereich. Rendert NUR die Kind-Routen via <Outlet/>.
// Der /worker-Inhalt (Dashboard) liegt in worker.index.tsx.
export const Route = createFileRoute('/worker')({
  component: WorkerAreaLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['worker']);
  },
});

function WorkerAreaLayout() {
  return <Outlet />;
}
